import { Routes, Route, Navigate } from "react-router";
import App from "./App";
import AuthPage from "./pages/AuthPage";
import Assistant from "./components/assistant/Assistant";
import Users from "./pages/Users";
import Responses from "./pages/Responses";
import Documents from "./pages/Documents";
import Settings from "./pages/Settings";
import Home from "./pages/Home";
import RootRedirect from "./components/RootRedirect";
import RoleRestrictedRoute from "./roleRestrictedRoute";
import { appConfig } from "./appConfig";
import Analytics from "./pages/Analytics";
import Costs from "./pages/Costs";
import Meeting from "./pages/Meeting";
import MeetingNotes from "./pages/MeetingNotes";
import MeetingNoteDetail from "./pages/MeetingNoteDetail";

const Router = () => {
  return (
    <Routes>
      <Route path="/auth" element={<AuthPage />} />
      <Route path="/" element={<App />}>
        <Route
          index
          element={
            <RoleRestrictedRoute allowedRoles={["member", "admin", "superadmin"]}>
              <RootRedirect />
            </RoleRestrictedRoute>
          }
        />
        <Route
          path="home"
          element={
            <RoleRestrictedRoute allowedRoles={["member", "admin", "superadmin"]}>
              <Home />
            </RoleRestrictedRoute>
          }
        />
        <Route
          path="assistant"
          element={
            <RoleRestrictedRoute allowedRoles={["member", "admin", "superadmin"]}>
              <Assistant key={window.location.search} />
            </RoleRestrictedRoute>
          }
        />
        <Route
          path="documents"
          element={
            <RoleRestrictedRoute allowedRoles={["admin", "superadmin"]}>
              <Documents />
            </RoleRestrictedRoute>
          }
        />
        <Route
          path="users"
          element={
            <RoleRestrictedRoute allowedRoles={["admin", "superadmin"]}>
              <Users />
            </RoleRestrictedRoute>
          }
        />
        {appConfig.features.analyticsDashboard && (
          <Route
            path="analytics"
            element={
              <RoleRestrictedRoute allowedRoles={["admin", "superadmin"]}>
                <Analytics />
              </RoleRestrictedRoute>
            }
          />
        )}
        {appConfig.features.costsDashboard && (
          <Route
            path="costs"
            element={
              <RoleRestrictedRoute allowedRoles={["superadmin"]}>
                <Costs />
              </RoleRestrictedRoute>
            }
          />
        )}
        <Route
          path="answers"
          element={
            <RoleRestrictedRoute allowedRoles={["admin", "superadmin"]}>
              <Responses />
            </RoleRestrictedRoute>
          }
        />
        <Route
          path="settings"
          element={
            <RoleRestrictedRoute allowedRoles={["admin", "superadmin"]}>
              <Settings />
            </RoleRestrictedRoute>
          }
        />
        <Route
          path="meeting"
          element={
            <RoleRestrictedRoute allowedRoles={["superadmin"]}>
              <Meeting />
            </RoleRestrictedRoute>
          }
        />
        <Route
          path="meeting-notes"
          element={
            <RoleRestrictedRoute allowedRoles={["superadmin"]}>
              <MeetingNotes />
            </RoleRestrictedRoute>
          }
        />
        <Route
          path="meeting-notes/:noteId"
          element={
            <RoleRestrictedRoute allowedRoles={["superadmin"]}>
              <MeetingNoteDetail />
            </RoleRestrictedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
};

export default Router;
